import { render, staticRenderFns } from "./plan-comparison-group.vue?vue&type=template&id=0c8a8b4b&scoped=true&"
import script from "./plan-comparison-group.vue?vue&type=script&lang=js&"
export * from "./plan-comparison-group.vue?vue&type=script&lang=js&"
import style0 from "./plan-comparison-group.vue?vue&type=style&index=0&id=0c8a8b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a8b4b",
  null
  
)

export default component.exports